import { Toaster } from 'react-hot-toast';
import { RouterProvider } from 'react-router-dom';

import { useAuthInit } from '@/hooks/useAuthInit';

import { appRoutes } from '@/routes';

function App() {
  useAuthInit();
  return (
    <>
      <RouterProvider router={appRoutes} />
      <Toaster reverseOrder={false} />
    </>
  );
}

export default App;
